var laGlobalProperty = (function() {
    var _laGlobalProperty;

    var _currentUserId;

    function init() {
        return {
            setCurrentUserId: function(currentUserId) {
                _currentUserId = currentUserId;
            },
            getCurrentUserId: function() {
                return _currentUserId;
            }
        };
    }

    return {
        getInstance: function() {
            if (!_laGlobalProperty) {
                _laGlobalProperty = init();
            }
            return _laGlobalProperty;
        },

        /**
         *
         */
        laServiceConst_TransData_isAutoLogin: 'TransData_isAutoLogin',
        /**
         *
         */
        laServiceConst_TransData_AutoLoginId: 'TransData_AutoLoginId',
        /**
         *
         */
        laServiceConst_TransData_AutoLoginPwd: 'TransData_AutoLoginPwd',
        /**
         *
         */
        laServiceConst_TransData_BackUrl: 'TransData_BackUrl',
        /**
         *
         */
        laServiceConst_TransData_QueryTicket: 'TransData_QueryTicket',
        /**
         *选座乘机人
         */
        laServiceConst_TransData_SelectSeatPassengerList: 'SelectSeatPassengerList',
        /**
         *
         */
        laServiceConst_TransData_ResultGetComplaintList: 'ResultGetComplaintList',
        /**
         *提交航班信息
         */
        laServiceConst_TransData_BookOrder: 'TransData_BookOrder',
        /**
         *提交改期航班信息
         */
        laServiceConst_TransData_TransBookOrder: 'TransData_TransBookOrder',
        /**
         *问卷提交时间
         */
        laServiceConst_TransData_QuestionSubmitTime: 'QuestionSubmitTime',
        /**
         *订单查询结果
         */
        laServiceConst_TransData_QueryOrderDetail: 'QueryOrderDetail',
        /**
         *
         */
        laServiceConst_TransData_OrderIdForCreate: 'TransData_OrderIdForCreate',
        /**
         *
         */
        laServiceConst_TransData_key_cookie_OrderInfo: 'key_cookie_OrderInfo',
        /**
         *处理信息编码说明
         */
        laServiceConst_AppId: 'ClientService',
        /**
         *处理成功
         */
        laServiceCode_Success: '0000',
        /*
         本地自定义错误代码
         */
        laServiceCode_ErrorLocal: '-99999',
        /*
         渠道:1:网页端
         */
        laServiceCode_SaleChannel: 19,
        //app 渠道
        H5AppSaleChannel: 7,
        //Url说明
        /*
         地址头
         */
        //laServiceUrl_Head: 'http://120.26.82.34/',
        /*
         接口主地址
         */
        //laServiceUrl_MainInterface: 'Flight/InterfaceService',

        /*

         */
        //laServiceDomain_SessionName : 'ASP.NET_SessionId',
        /*
         接口地址正式

         */
        laServiceUrl_Interface: '/webhandler.ashx',
        // laServiceUrl_Interface: '/WebHandler.ashx',
        // 接口地址测试
        laServiceTestUrl_Interface: "/dist/webhandler.ashx",
        /*
         查找航班
         */
        laServiceUrl_ActionType_SearchFlight: "FlightService_FlightSearchHandler",
        /*
         获取航班地图
         */
        laServiceUrl_ActionType_GetFlightSeatMap: "FlightService_GetFlightSeatMapHandler",
        /*
         登入
         */
        laServiceUrl_ActionType_Login: "AccountService_UserLoginHandler",
        /*
         创建订单
         */
        laServiceUrl_ActionType_CreateOrder: "OrderService_CreateOrderHandler",
        /*
         订单列表
         */
        laServiceUrl_ActionType_OrderList: "OrderService_OrderListHandler",
        /*
         订单详细信息
         */
        laServiceUrl_ActionType_OrderInfo: "OrderService_OrderDetialHandler",
        /*
         获取支付链接
         */
        laServiceUrl_ActionType_PayUrl: "OrderService_GetPayUrlHandler",
        /*
         退票
         */
        laServiceUrl_ActionType_RefundOrder: "OrderService_RefundOrderHandler",
        /*
         获取退票详细信息
         */
        laServiceUrl_ActionType_RefundOrderInfo: 8,
        /*
         获取退票详细信息
         */
        laServiceUrl_ActionType_RefundOrderList: 9,
        /*
         获取退票乘客
         */
        laServiceUrl_ActionType_RefundOrderPassenger: 10,
        /*
         注册
         */
        laServiceUrl_ActionType_RegisterUser: "AccountService_UserRegisterHandler",
        /*
         发送注册验证码
         */
        laServiceUrl_ActionType_SendRegisterMobileCode: "AccountService_GetPhoneVerifyCodeHandler",
        /*
         查询当前登录用户信息
         */
        laServiceUrl_ActionType_GetCurrentUserInfo: "AccountService_UserDetailInfoHandler",
        /*
         获取支付方式
         */
        laServiceUrl_ActionType_GetPayChannelList: "OrderService_GetPayWaysHandler",
        /*
         发送找回密码的验证码
         */
        laServiceUrl_ActionType_SendFindPwdMobileCode: 15,
        /*
         修改密码
         */
        laServiceUrl_ActionType_ChangeLoginPwd: 'AccountService_UserChangePwdHandler',
        /*
         找回密码
         */
        laServiceUrl_ActionType_FindLoginPassword: "AccountService_UserRetrievePwdHandler",
        /*
         查询常用乘机人列表
         */
        laServiceUrl_ActionType_QueryStationPassengers: "AccountService_FrequentFlierListHandler",
        /*
         常用乘机人添加
         */
        laServiceUrl_ActionType_MaintainStationPassengers: "AccountService_FrequentFlierAddHandler",
        /*
         常用乘机人修改
         */
        laServiceUrl_ActionType_MaintainModifyPassengers: "AccountService_FrequentFlierModifyHandler",
        /*
         查询常用乘机人详情
         */
        laServiceUrl_ActionType_QueryStationPsgDetail: 20,
        /*
         退出登录
         */
        laServiceUrl_ActionType_UserLogOut: "AccountService_UserLogoutHandler",
        /*
         取消订单
         */
        laServiceUrl_ActionType_CancelOrder: "OrderService_OrderCancelHandler",
        /**
         * 删除常旅客
         */
        laServiceUrl_ActionType_DelMaintainStationPassengers: "AccountService_FrequentFlierDeleteHandler",
        /**
         * 获取机场信息
         */
        laServiceUrl_ActionType_QueryAirportList: "FlightService_AirportHandler",
        /*
         未登录状态获取订单详细信息
         */
        laServiceUrl_ActionType_OrderInfoWithoutLogin: "OrderService_OrderDetialNotLoginHandler",
        /*
         未登录状态退票
         */
        laServiceUrl_ActionType_RefundOrderWithoutLogin: 26,
        /*
         未登录状态下获取订单信息的查询验证码
         */
        laServiceUrl_ActionType_OrderInfoImgVerifyCode: "AccountService_GetImageVerifyCodeHandler",
        /*
         查询特价机票
         */
        laServiceUrl_ActionType_QuerySpecialTicket: "FlightService_SpecialOfferTicketsHandler",
        /*
         * 修改个人信息
         */
        laServiceUrl_ActionType_ModifyUserInfo: "AccountService_UserInfoModifyHandler",
        /*
         发送手机验证码-修改个人信息
         */
        laServiceUrl_ActionType_SendMobileCodeForModifyUserInfo: 30,
        /*
         客票验真
         */
        laServiceUrl_ActionType_CheckTicket: "OrderService_TicketCheckHandler",
        /*
         客票验证图片验证码
         */
        laServiceUrl_ActionType_CheckTicketImgVerifyCode: 'AccountService_GetImageVerifyCodeHandler',
        /*
         查询航班动态
         */
        laServiceUrl_ActionType_QueryFlightDynamic: "FlightService_DynamicsResultHandler",
        /*
         注册时发送短信前获取图片验证码
         [Description("注册")]
         Register = 1,
         [Description("修改手机号")]
         ChangePhoneNumber = 2,
         [Description("找回密码")]
         RetrievePwd = 3,
         [Description("客票验真")]
         TicketCheckResultImageCode = 4,
         [Description("修改个人信息")]
         ChangePersonalMessage = 5,
         [Description("用户登录")]
         UserLogin = 6,
         [Description("未登录下查询订单")]
         OrderSearch = 7,
         */
        laServiceUrl_ActionType_ImageVerifyCodeForRegister: 'AccountService_GetImageVerifyCodeHandler',
        /*
         查询机票日历
         */
        laServiceUrl_ActionType_QueryPriceCalendar: "FlightService_LowPriceHandler",
        /*
         查询旅客行程
         */
        laServiceUrl_ActionType_QueryPassengerTravel: "OrderService_CheckInInfoHandler",
        /*
         离港座位图查询
         */
        laServiceUrl_ActionType_QueryPlaneSeats: "OrderService_SeatMapHandler",
        /*
         单人值机
         */
        laServiceUrl_ActionType_OnlineCheckin: "OrderService_CheckInHandler",
        /*
         取消值机
         */
        laServiceUrl_ActionType_OnlineCheckinCancel: "OrderService_CancelCheckInHandler",
        /*
         获取快递渠道
         */
        laServiceUrl_ActionType_QueryExpress: "FlightService_GetExpressExpensesHandler",
        /*
         发送注册验证码
         */
        laServiceUrl_ActionType_BookingTicketValidCode: "AccountService_GetImageVerifyCodeHandler",
        /*
         常旅客注册
         */
        laServiceUrl_ActionType_RegisterFrequentUser: 44,
        /*
         机票改期
         */
        laServiceUrl_ActionType_TransFlight: "OrderService_TicketChangeHandler",
        /*
         * 查询改期航班
         */
        laServiceUrl_ActionType_QueryFlightForTrans: "OrderService_GetChangeFlightsHandler",
        /*
         * 查询新闻类型
         */
        laServiceUrl_ActionType_QueryArticleType: "ArticleService_B2C_GetArticleTypeList",
        /*
         * 查询新闻列表
         */
        laServiceUrl_ActionType_QueryNewsList: "ArticleService_B2C_GetArticleListHandler",
        /*
         * 查询新闻详情
         */
        laServiceUrl_ActionType_QueryNewsDetail: "ArticleService_B2C_GetArticleInfoByTidHandler",
        /**
         * 动态新闻列表
         */
        laServiceUrl_ActionType_QueryDyNewsList: 49,
        /**
         * 动态新闻详情列表
         */
        laServiceUrl_ActionType_QueryDyNewsDetail: 50,
        /**
         * 快速登入或注册图片验证码
         */
        laServiceUrl_ActionType_QuickLoginOrRegisterImageVerifyCode: 52,
        /**
         * 快速登入或注册手机验证码
         */
        laServiceUrl_ActionType_SendQuickLoginOrRegisterVerifyCode: 53,
        /**
         * 快速登入或注册
         */
        laServiceUrl_ActionType_QuickLoginOrRegister: 54,


        /**
         * 不正常航班查询
         */
        laServiceUrl_ActionType_QueryIrregularFlight: "AbnormalFlightService_AbnormalDetrTNHandler",
        /**
         * 获取不正常航班详细信息
         */
        laServiceUrl_ActionType_QueryIrregularFlightDetail: "AbnormalFlightService_GetAbnormalFlightInfoHandler",
        /**
         * 发送不正常航班证明邮件
         */
        laServiceUrl_ActionType_SendIrregularFlightEMail: 3003,
        /**
         * 特殊餐食预订
         */
        laServiceUrl_ActionType_QuerySpecialMealPidDetrTN: "SpecialService_SpecialMealDetrTNHandler",
        /**
         * 申请特殊餐食
         */
        laServiceUrl_ActionType_ApplySpecialMeal: "SpecialService_ApplySpecialMealHandler",
        /**
         * 取消特殊餐食
         */
        laServiceUrl_ActionType_CancelSpecialMeal: "SpecialService_CancelSpecialMealHandler",
        /**
         * 招投标公告列表
         */
        laServiceUrl_ActionType_QueryBiddingsList: 58,
        /**
         * 招投标公告详情
         */
        laServiceUrl_ActionType_QueryBiddingsDetail: 59,
        /**
         *检查是否可以改期
         */
        laServiceUrl_ActionType_CheckCanTrans: "OrderService_CheckIsCanChangeHandler",
        /**
         * 问卷调查
         */
        laServiceUrl_ActionType_SendQuestionnaireAnswer: "ServiceQualityService_FinishExamHandler",
        /**
         * 投诉与建议 提交信息
         */
        laServiceUrl_ActionType_CreateComplaint: "ServiceQualityService_CreateComplaintHandler",
        /**
         * 投诉与建议 查询信息
         */
        laServiceUrl_ActionType_UploadEnclosure: "ServiceQualityService_GetComplaintListHandler",
        /**
         * 申请特殊旅客特殊服务
         */
        laServiceUrl_ActionType_ApplySpecialService: "SpecialService_ApplySpecialServiceHandler",
        /**
         * 查询特殊旅客特殊服务信息接口
         */
        laServiceUrl_ActionType_CheckSpecialService: "SpecialService_GetSpecialServiceInfoHandler",
        /**
         * 取消特殊旅客特殊服务接口
         */
        laServiceUrl_ActionType_CancelSpecialService: "SpecialService_CancelSpecialServiceHandler",
        /**
         * 根据单号查询详细信息
         */
        laServiceUrl_ActionType_GetSpecialServiceDetail: "SpecialService_GetSpecialServiceDetailHandler",
        /**
         * 补订儿童/婴儿票时根据票号姓名查航班信息
         */
        laServiceUrl_ActionType_SpecialServiceDetrTN: "FlightService_AdultDetrTNHandler",
        /**
         * 创建行程单订单
         */
        laServiceUrl_ActionType_CreateItineraryOrder: "OrderService_AddItineraryOrderHandler",
        /**
         * 查询行程单订单列表
         */
        laServiceUrl_ActionType_QueryItineraryOrderList: "OrderService_ItineraryOrderHandler",
        /**
         * 查询行程
         */
        laServiceUrl_ActionType_ItineraryOrderDetr: "OrderService_ItineraryOrderDetrHandler",
        /**
         * 创建行程单退款订单
         */
        laServiceUrl_ActionType_CreateRefundItineraryOrder: "OrderService_RefundItineraryOrderHandler",
        /**
         * 查询行程单订单详情
         */
        laServiceUrl_ActionType_QueryItineraryOrderDetail: "OrderService_GetItineraryOrderDetailHandler",
        /**
         获取行程单订单支付链接
         */
        laServiceUrl_ActionType_PayItineraryOrderUrl: "OrderService_GetPayUrlHandler", //3406,
        /**
         0元支付
         */
        laServiceUrl_ActionType_ChangePay0: "OrderService_ChangePayStatus", //3406,
        /**
         * 特殊服务
         */
        laServiceUrl_ActionType_QuerySpecialServicePidDetrTN: "SpecialService_SpecialServiceDetrTNHandler",
        /**
         * 申请停车退票
         */
        laServiceUrl_ActionType_RefundParkOrder: 3650,
        /**
         * 获取停车城市和价格
         */
        laServiceUrl_ActionType_ReturnParkCityUnitPrice: "FlightService_GetParkProviderHandler",
        /**
         * 旅行助手查询信息列表
         */
        laServiceUrl_ActionType_InformationList: 5010,
        /**
         * 旅行助手查询信息详情
         */
        laServiceUrl_ActionType_InformationDetail: 5020,
        /**
         * 根据票号、出发城市三字码、达到城市三字码查询电子登机牌信息
         */
        laServiceUrl_ActionType_DownLoadBoardingPass: "OrderService_BarBoardingPassHandler",
        /*
         微信登录
         */
        laServiceUrl_ActionType_WeixinLogin: "AccountService_WeChatLoginHandler",
        /*

         获取微信登录状态
         */
        laServiceUrl_ActionType_WeiXinwechatLogin: "AccountService_WeChatLoginHandler",
        /*
         微信绑定
         */
        laServiceUrl_ActionType_WeiXinwechatBinding: "AccountService_WeChatBindingHandler",
        /*
         微信校验
         */
        laServiceUrl_ActionType_WeChatVerify: "AccountService_WeChatValidateHandler",
        /*
         是否需要校验
         */
        laServiceUrl_ActionType_ReserveVerify: "OrderService_ReserveValidateHandler",

        /*
        获取国籍信息列表
         */
        laServiceUrl_ActionType_GetAllCountryInfo: "FlightService_GetAllCountryInfo",
        /*
         获取4周年活动结果
         */
        laServiceUrl_ActionType_FourYearInfo: 5040,
        laServiceUrl_ActionType_TeamLogin: "AccountService_AgentLoginHandler", //团队登陆
        laServiceUrl_ActionType_GetOrgAgentDetail: "AccountService_GetOrgAgentDetailHandler", //获取常旅客信息
        laServiceUrl_ActionType_TeamRegist: 'AccountService_OrgAgentResignHandler', //团队注册
        laServiceUrl_ActionType_TeamFlightSearch: 'FlightService_TeamFlightSearchHandler', //团队航班查询
        laServiceUrl_ActionType_CreateTeamOrder: 'OrderService_FirstCreateTeamOrderHandler', //团队订单创建
        laServiceUrl_ActionType_GetTeamOrderInfoDetail: "OrderService_GetTeamOrderInfoDetailHandler", //团队订单
        laServiceUrl_ActionType_ImportTeamPassenger: "OrderService_ImportTeamPassengerHandler", //导入团队名单
        laServiceUrl_ActionType_CancelTeamOrder: "OrderService_CancelTeamOrderHandler", //取消团队订单
        laServiceUrl_ActionType_ConfirmTeamOrder: "OrderService_ConfirmTeamOrderHandler", //确认订单
        laServiceUrl_ActionType_GetTeamOrderInfoList: "OrderService_GetTeamOrderInfoListHandler", //获取订单list
        laServiceUrl_ActionType_GetTeamStockDistributeForAgent: "FlightService_GetTeamStockDistributeForAgentHandler", //获取计划位列表
        laServiceUrl_ActionType_DepositPay: "OrderService_DepositPayHandler", //支付押金
        laServiceUrl_ActionType_GetDepositOrderDetailInfo: "OrderService_GetDepositOrderDetailInfoHandler", //押金类表
        /**
         * 票后选座身份信息验证
         */
        laServiceUrl_ActionType_ChooseSeatValidate: "ChooseSeatService_ChooseSeatValidate",
        laServiceUrl_ActionType_ChooseSeatService_ChooseSeat: "ChooseSeatService_ChooseSeat",
        // 动态验证码登录
        AccountService_MobileLogin: "AccountService_MobileLoginHandler",
        //在线值机
        laServiceUrl_ActionType_CheckInInfoByFoidHandler: "OrderService_CheckInInfoByFoidHandler",
        laServiceUrl_ActionType_QrBoardingPassHandler: "OrderService_QrBoardingPassHandler",
        laServiceUrl_ActionType_UserDetailInfo: "AccountService_UserDetailInfoHandler",
        //补全信息
        laServiceUrl_ActionType_ComplementUserInfoHandler: "AccountService_ComplementUserInfoHandler",
        //修改手机号（登录名）
        laServiceUrl_ActionType_ChangeLoginNameHandler: "AccountService_ChangeLoginNameHandler",
        //退单详情
        laServiceUrl_ActionType_GetUIRefundSaleOrderDetail: "OrderService_GetUIRefundSaleOrderDetail",
        //WeChat获取OpenID
        laServiceUrl_ActionType_WeChatPro_GetWeiXinOpenId: "WeChatPro_GetWeiXinOpenId",
        //获取推广二维码
        laServiceUrl_ActionType_WeChatPro_GetQRTicket: "WeChatPro_GetQRTicket",
        //二维码推广员工登录
        laServiceUrl_ActionType_WeChatPro_Login: "WeChatPro_Login",
        // 获取活动列表
        CabinActive_Service_GetActivityList: "CabinActiveService_GetActivityList",
        //获取中奖名单
        laServiceUrl_ActionType_ActivityWinnerList: "CabinActiveService_ActivityWinnerList",
        //创建订单
        CabinActiveService_Apply: "CabinActiveService_Apply",
        //获取申请列表
        laServiceUrl_ActionType_ApplyHistory: "CabinActiveService_ApplyHistory",
        // 校验是否可以抢购
        CabinActiveService_CheckCanApply: "CabinActiveService_CheckCanApply",
        // x舱航班查询
        CabinActiveService_SearchFlight: "CabinActiveService_SearchFlight",
        // 获取邮寄信息
        FlightService_GetExpressExpensesHandler: "FlightService_GetExpressExpensesHandler",
        // 获取酒店地址列表
        getCityList: "getCityList",
    };
})();

export default laGlobalProperty;


// WEBPACK FOOTER //
// ./src/assets/js/globalProperties.js